import { render } from "./overview.vue?vue&type=template&id=c089d0f8&scoped=true"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"

import "./overview.vue?vue&type=style&index=0&id=c089d0f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c089d0f8"]])

export default __exports__